module.exports = __webpack_public_path__ + "assets/new_en.876c94a51c5d3d7aa85dc276dcce0d7e.png";